// Maps a frontend domain (window.location.hostname) to its backend base URL.
// Add new domains here so a single build can serve multiple environments.
const BACKEND_BY_HOST: { [host: string]: string } = {
  'gamma.rgp-dev.com': 'https://exa-backend.rgp-dev.com/',
  'staging-v2.rgp-dev.com': 'https://staging-backend.rgp-dev.com/',
  'staging.rgp-dev.com': 'https://staging-backend.rgp-dev.com/',
  'playground.robogarden.ca': 'https://backend.robogarden.ca/'
};

// fallback to production.
const DEFAULT_BACKEND = 'https://backend.robogarden.ca/';

function resolveBackendBaseUrl(): string {
  const host =
    (typeof window !== 'undefined' && window.location && window.location.hostname) || '';

  if (BACKEND_BY_HOST[host]) {
    return BACKEND_BY_HOST[host];
  }

  // Any robogarden.ca subdomain falls back to the production backend.
  if (host.endsWith('robogarden.ca')) {
    return 'https://backend.robogarden.ca/';
  }

  return DEFAULT_BACKEND;
}

export function buildBackendUrl(): string {
  const baseUrl = resolveBackendBaseUrl();
  const language = localStorage.getItem('language') || 'en';
  return `${baseUrl}${language}/`;
}
